export default {
      id: "edit-usage",
      viewBox: "0 0 512 511.99",
      url: __webpack_public_path__ + "img/svg-sprite.svg#edit",
      toString: function () {
        return this.url;
      }
    }